import React, {
  useState,
  Fragment,
  useCallback,
  useEffect,
  useRef,
} from "react";
import "./Demo.css";
import { backend, API_URL } from "../../../config";
import { useTheme } from "@mui/material/styles";
import {
  Container,
  CssBaseline,
  Grid,
  IconButton,
  Typography,
  Divider,
  CircularProgress,
  useMediaQuery,
  Modal,
  Button,
  Snackbar,
} from "@mui/material";
import {
  Dashboard,
  TableRows,
  Smartphone,
  Edit,
  QrCode,
  FileCopy,
} from "@mui/icons-material";
import { makeStyles } from "@mui/styles";

import { QRCodeCanvas, QRCodeSVG } from "qrcode.react";

import { Link } from "react-router-dom";

import CardItem from "../../../components/Cards/Items/Items";
import ListItem from "../../../components/Cards/ListItems/ListItems";
import ItemDialog from "../../../components/Dialogs/Items/Items";
import InfiniteTable from "../../../components/InfiniteTable/InfiniteTable";

import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  modal: {
    position: "absolute",
    width: 400,
    backgroundColor: "#fff",
    border: "1px solid rgba(0,0,0,.2)",
    borderRadius: ".3rem",
    boxShadow: theme.shadows[5],
    padding: "1rem",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

const columnsOrderList = [
  {
    id: "upc",
    label: "UPC",
    exportable: false,
    visibility_allow_rid: [1, 2, 3, 4, 5, 6, 7, 8, 9],
  },
  {
    id: "item_codee",
    label: "Item Code",
    exportable: true,
  },
  {
    id: "od_category_name",
    label: "Category",
    exportable: true,
  },
  {
    id: "name",
    label: "Name",
    exportable: true,
  },
  {
    id: "size",
    label: "Size",
    exportable: true,
  },
  {
    id: "display_unit_price",
    label: "Unit",
    exportable: true,
  },
  {
    id: "display_case_price",
    label: "Case",
    exportable: true,
  },
  {
    id: "combined_stock_level",
    label: "Combined Stock",
    visibility_deny_rid: [32],
    exportable: false,
  },
  {
    id: "stock_level_indicator",
    label: "Stock",
    visibility_allow_rid: [32],
    exportable: false,
  },
  {
    id: "url",
    label: "",
    exportable: false,
  },
  {
    id: "_acceptable_substitution_",
    label: "",
    exportable: false,
    visibility_allow_rid: [
      1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
      22, 23, 24, 25, 26, 27, 28, 29,
    ],
  },
];

const showPricing = false;

export const OrdersDemo = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();

  const pngRef = useRef(null);
  const svgRef = useRef(null);

  const xsWidth = useMediaQuery(theme.breakpoints.only("xs"));

  const initialStateSelectedItem = {
    id: 0,
    image: "",
    code: "",
    name: "",
    price: 0,
    count: 0,
    description: "",
    upc: "",
    location: "",
  };

  const currentUserStore = useSelector((state) => state.current_user);

  const [openItemDialog, setOpenItemDialog] = useState(false);
  const [selectedItem, setSelectedItem] = useState(initialStateSelectedItem);
  const [view, setView] = useState(1);
  const [orderList, setOrderList] = useState([]);
  const [orderListData, setOrderListData] = useState([]);
  const [orderListCustomer, setOrderListCustomer] = useState([]);
  const [orderListFull, setOrderListFull] = useState([]);
  const [orderListPricing, setOrderListPricing] = useState([]);
  const [orderListPricingLoaded, setOrderListPricingLoaded] = useState(false);
  const [orderListLoaded, setOrderListLoaded] = useState(false);
  const [orderListLoading, setOrderListLoading] = useState(true);
  const [orderListMapped, setOrderListMapped] = useState(false);
  const [orderListFiltered, setOrderListFiltered] = useState(false);
  const [products, setProducts] = useState([]);
  const [productsLoaded, setProductsLoaded] = useState(false);
  const [copied, setCopied] = useState(false);
  const [qrModal, setQRModal] = useState(false);
  const [cURL, setCURL] = useState(null);
  const [bannerVisible, setBannerVisible] = useState(false);
  const [bannerDismissed, setBannerDismissed] = useState(false);
  const [scrollDir, setScrollDir] = useState("down");

  const isInternalUser = currentUserStore && currentUserStore.role_id < 12;

  const closeBanner = () => {
    setBannerVisible(false);
    setBannerDismissed(true);
  };

  const handleClickCopy = () => {
    navigator.clipboard.writeText(cURL);
    setCopied(true);
  };

  const handleCloseCopy = () => {
    setCopied(false);
  };

  const toggleQRModal = () => setQRModal(!qrModal);

  const qrModalContent = (
    <div className={classes.modal}>
      <div style={{ textAlign: "center" }}>
        <QRCodeCanvas
          ref={pngRef}
          value={cURL}
          fgColor="#b45b4d"
          size={256}
          marginSize={4}
        />
      </div>
      <div align="right">
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleClickDownloadPNG()}
          className={classes.button}
        >
          Download PNG
        </Button>
      </div>
      <br />
      <div ref={svgRef} style={{ textAlign: "center" }}>
        <QRCodeSVG value={cURL} fgColor="#b45b4d" size={256} marginSize={4} />
      </div>
      <br />
      <div align="right">
        <Button onClick={() => toggleQRModal()} className={classes.button}>
          Close
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleClickDownloadSVG()}
          className={classes.button}
        >
          Download SVG
        </Button>
      </div>
    </div>
  );

  function downloadBlob(blob, filename) {
    const objectUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setTimeout(() => URL.revokeObjectURL(objectUrl), 5000);
  }

  const handleClickDownloadPNG = useCallback(() => {
    const content = pngRef.current;

    if (content === null) return;

    content.toBlob((blob) => {
      downloadBlob(blob, "qrcode-png.png");
    }, "image/png");
  }, []);

  const handleClickDownloadSVG = useCallback(() => {
    const content = svgRef.current.children[0].innerHTML;

    if (content === null) return;

    const contentWithSvg = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" height="256" width="256" viewBox="0 0 33 33">${content}</svg>`;
    const blob = new Blob([contentWithSvg], { type: "image/svg+xml" });
    downloadBlob(blob, "qrcode-svg.svg");
  }, []);

  const handleClickCardView = () => {
    setView(1);
  };

  const handleClickTableView = () => {
    setView(2);
  };

  const handleClickCondensedView = () => {
    setView(3);
  };

  const orderNowElement = () =>
    orderListMapped ? (
      <Grid item xs={12} sm={12} style={{ textAlign: "center" }}>
        <Typography variant="h6" component="div" color="primary">
          Order Now!
        </Typography>
        orders@friendly-foods.com
        <br />
        323-653-5900
        <Typography variant="h6" component="div" color="primary">
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              history.push("/?signup");
            }}
          >
            Create Account
          </Button>
        </Typography>
        <Typography variant="caption" color="textSecondary">
          Start enjoying our prices and fast delivery.
        </Typography>
      </Grid>
    ) : (
      <></>
    );

  useEffect(() => {
    const getOrderList = async () => {
      const [, olName] = cURL.split("/demo/");

      if (!cURL.includes("/demo/")) {
        setOrderListFull([]);
        setOrderListLoaded(true);
        setOrderListLoading(false);
      } else {
        const olNameFormatted = olName.replaceAll("-", " ").toLowerCase();

        await backend
          .get(`${API_URL}orderlists?no_page=1&public=true`)
          .then(({ data }) => {
            setOrderListFull(
              data.filter((item) => {
                const itemPublicName = item?.public_name
                  ? item.public_name
                  : item?.customer?.username || "Unknown Order Guide";

                return itemPublicName?.toLowerCase() === olNameFormatted;
              }),
            );
            setOrderListLoaded(true);
            setOrderListLoading(false);
          });
      }
    };

    const getOrderListPricing = () => {
      let orderListPricingArray = [];

      if (!showPricing) {
        setOrderListPricing(orderListPricingArray);
        setOrderListPricingLoaded(true);
        return;
      }

      Promise.all(
        orderListFull.map(async (item) => {
          await backend
            .get(`${API_URL}orderlistprices?no_page=1&order_list=${item.id}`)
            .then(({ data }) => {
              orderListPricingArray = [...orderListPricingArray, ...data];
            });
        }),
      ).then(() => {
        setOrderListPricing(orderListPricingArray);
        setOrderListPricingLoaded(true);
      });
    };

    const getOrderListProducts = () => {
      let productsArray = [];

      Promise.all(
        orderListFull.map(async (item) => {
          await backend
            .get(
              `${API_URL}products?include_inactive=true&include_nonprimary=true&no_page=1&order_list=${item.id}`,
            )
            .then(({ data }) => {
              let productsMap = data.map((item) => ({
                ...item,
                unit_in_cart: 0,
                case_in_cart: 0,
                added_in_cart: false,
                added_through_sub: false,
              }));

              if (!showPricing) {
                productsMap = productsMap.map((product) => ({
                  ...product,
                  api_case_price: null,
                  api_unit_price: null,
                  display_case_price: null,
                  display_unit_price_per_lb: null,
                  display_case_price_per_lb: null,
                  display_unit_price: null,
                  prime_price: null,
                }));
              }

              productsArray = [...productsArray, ...productsMap];
            });
        }),
      ).then(() => {
        setProducts(productsArray);
        setProductsLoaded(true);
      });
    };

    const orderListMapping = () => {
      let customerOrderListRows = [];
      const customerOrderList = orderListFull.map((item) => {
        const categoriesDisplay = item.categories.map((catItem) => {
          const rowsMapped = catItem.rows.map((rowItem) => {
            const productObj = products.find(
              (product) => product.upc === rowItem.product_id,
            );
            const productPricingObj = orderListPricing.find(
              (product) => product.upc === rowItem.product_id,
            );

            return {
              ...rowItem,
              ...productObj,
              ...productPricingObj,
              od_category_name: catItem.category_name,
              item_codee: productObj ? productObj.item_code.item_code : "",
            };
          });

          customerOrderListRows = [...customerOrderListRows, ...rowsMapped];

          return { ...catItem, rows: rowsMapped };
        });

        return {
          ...item,
          categories: categoriesDisplay,
        };
      });

      if (!orderListCustomer.length) {
        setOrderListCustomer(customerOrderList);
      }

      setOrderList(customerOrderList);
      setOrderListData(customerOrderListRows);
      setOrderListMapped(true);
      setOrderListFiltered(false);
    };

    if (cURL !== null && !orderListFull.length && !orderListLoaded) {
      getOrderList();
    } else if (
      orderListFull.length &&
      orderListLoaded &&
      !orderListPricingLoaded
    ) {
      getOrderListPricing();
    } else if (orderListFull.length && orderListLoaded && !productsLoaded) {
      getOrderListProducts();
    } else if (orderListPricingLoaded && !orderListMapped && productsLoaded) {
      orderListMapping();
    }
  }, [
    cURL,
    orderListCustomer,
    orderListFull,
    orderListLoaded,
    orderListMapped,
    orderListPricing,
    orderListPricingLoaded,
    products,
    productsLoaded,
  ]);

  useEffect(() => {
    setCURL(
      window.location
        ? window.location.href
        : "https://fforders.com/demo/Friendly-Foods-Guest-Accout",
    );
  }, []);

  useEffect(() => {
    if (!orderListMapped) return;
    if (isInternalUser) return;
    if (bannerDismissed) return;

    let lastY = window.scrollY;
    let ticking = false;

    const onScroll = () => {
      if (ticking) return;
      ticking = true;

      window.requestAnimationFrame(() => {
        const y = window.scrollY;
        const doc = document.documentElement;
        const maxScroll = Math.max(1, doc.scrollHeight - window.innerHeight);
        const progress = y / maxScroll;
        const delta = y - lastY;

        if (Math.abs(delta) > 14) {
          setScrollDir(delta > 0 ? "down" : "up");
        }

        const inTopZone = progress <= 0.08;
        const inBottomZone = progress >= 0.95;
        const inMiddleZone = !inTopZone && !inBottomZone;

        if (inMiddleZone && Math.abs(delta) > 10) {
          setBannerVisible(true);
        } else if (inTopZone || inBottomZone) {
          setBannerVisible(false);
        }

        lastY = y;
        ticking = false;
      });
    };

    window.addEventListener("scroll", onScroll, { passive: true });

    return () => window.removeEventListener("scroll", onScroll);
  }, [orderListMapped, isInternalUser, bannerDismissed]);

  return (
    <Fragment>
      <CssBaseline />
      <Container maxWidth="lg" className="container">
        {!orderListLoaded ? (
          <div style={{ textAlign: "center" }}>
            <CircularProgress />
            <div>Matching Order Guide...</div>
          </div>
        ) : orderListLoaded && !orderListFull.length ? (
          <>
            We couldn't find any Order Guide with that name. Please contact
            Friendly Foods directly.
          </>
        ) : (
          <>
            <Snackbar
              open={copied}
              autoHideDuration={2000}
              onClose={handleCloseCopy}
              message="URL copied to clipboard."
            />
            <Modal open={qrModal}>{qrModalContent}</Modal>
            <Grid
              container
              spacing={2}
              alignItems="center"
              style={{ paddingBottom: xsWidth ? 100 : "inherit" }}
            >
              <Grid item xs={true} sm={true}>
                <Typography variant="h6" component="div">
                  {orderList.length ? orderList[0].company_location_name : ""}
                </Typography>
              </Grid>
              <>
                <Grid item xs={"auto"} sm={"auto"}>
                  {currentUserStore && currentUserStore.role_id < 12 ? (
                    <>
                      <IconButton onClick={toggleQRModal}>
                        <QrCode />
                      </IconButton>
                      <IconButton onClick={handleClickCopy}>
                        <FileCopy />
                      </IconButton>
                    </>
                  ) : (
                    <></>
                  )}
                  <IconButton onClick={handleClickCardView}>
                    <Dashboard className={view === 1 ? "activeView" : ""} />
                  </IconButton>
                  <IconButton onClick={handleClickTableView}>
                    <TableRows className={view === 2 ? "activeView" : ""} />
                  </IconButton>
                  <IconButton onClick={handleClickCondensedView}>
                    <Smartphone className={view === 3 ? "activeView" : ""} />
                  </IconButton>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Divider />
                </Grid>
                {orderNowElement()}
                {view === 1 ? (
                  <>
                    {productsLoaded ? (
                      <>
                        {orderListLoading ||
                        (orderListFull.length && !orderListMapped) ? (
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            style={{ textAlign: "center" }}
                          >
                            <div>Loading Order Guide ...</div>
                          </Grid>
                        ) : (
                          <></>
                        )}
                        {orderList.length &&
                        (orderListMapped || orderListFiltered) ? (
                          orderList.map((olItem) =>
                            olItem.categories.map((category, catIndex) => (
                              <Grid item xs={12} key={`cat-${catIndex}`}>
                                <div
                                  style={{
                                    fontSize: "135%",
                                    fontWeight: "bold",
                                    textTransform: "uppercase",
                                    marginBottom: 10,
                                  }}
                                >
                                  {category.category_name}
                                  {currentUserStore &&
                                  currentUserStore.role_id < 12 ? (
                                    <Link
                                      to={`/customer/${olItem.company_location}?orderlist=1`}
                                      style={{
                                        textDecoration: "none",
                                        marginLeft: 8,
                                      }}
                                    >
                                      <IconButton>
                                        <Edit />
                                      </IconButton>
                                    </Link>
                                  ) : (
                                    <></>
                                  )}
                                </div>
                                <Grid container spacing={3} textAlign="center">
                                  {category.rows.map((item, index) => (
                                    <Grid
                                      item
                                      xs={12}
                                      sm={6}
                                      md={4}
                                      lg={3}
                                      key={`cat-${catIndex}-item-${index}`}
                                    >
                                      <CardItem
                                        {...props}
                                        type={1}
                                        data={item}
                                        setSelectedItem={setSelectedItem}
                                        setOpenItemDialog={setOpenItemDialog}
                                      />
                                    </Grid>
                                  ))}
                                  {!category.rows.length ? (
                                    <>
                                      <Grid item xs={12} sm={12}>
                                        There are no products assigned to this
                                        category
                                      </Grid>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </Grid>
                              </Grid>
                            )),
                          )
                        ) : (
                          <>
                            {!orderListLoading && !orderListFull.length ? (
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                style={{ textAlign: "center" }}
                              >
                                <div>
                                  There are no Order Guide assigned to this
                                  customer
                                </div>
                              </Grid>
                            ) : (
                              <></>
                            )}
                          </>
                        )}
                      </>
                    ) : (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        style={{ textAlign: "center" }}
                      >
                        <CircularProgress />
                        <div>Loading products...</div>
                      </Grid>
                    )}
                  </>
                ) : view === 2 ? (
                  <>
                    {orderListData.length ? (
                      <Grid item xs={12}>
                        <InfiniteTable
                          {...props}
                          apiep={null}
                          columns={columnsOrderList}
                          data={orderListData}
                          dataMapByColumn="id"
                          deletable={false}
                          editable={true}
                          filterable={true}
                          label="Order Guide"
                          fetchingModal={null}
                        />
                      </Grid>
                    ) : (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        style={{ textAlign: "center" }}
                      >
                        <div>
                          {orderListLoading ||
                          (orderListFull.length && !orderListMapped)
                            ? `Loading Order Guide ...`
                            : `There are no Order Guide assigned to this customer`}
                        </div>
                      </Grid>
                    )}
                  </>
                ) : (
                  <>
                    {productsLoaded ? (
                      <>
                        {orderListLoading ||
                        (orderListFull.length && !orderListMapped) ? (
                          <Grid item xs={12} style={{ textAlign: "center" }}>
                            <div>Loading Order Guide ...</div>
                          </Grid>
                        ) : (
                          <></>
                        )}
                        {orderList.length &&
                        (orderListMapped || orderListFiltered) ? (
                          orderList.map((olItem) =>
                            olItem.categories.map((category, catIndex) => (
                              <Grid
                                item
                                xs={12}
                                key={`condensed-cat-${catIndex}`}
                              >
                                <div
                                  style={{
                                    fontSize: "135%",
                                    fontWeight: "bold",
                                    textTransform: "uppercase",
                                    marginBottom: 10,
                                  }}
                                >
                                  {category.category_name}
                                </div>
                                <Grid container spacing={1} textAlign="center">
                                  {category.rows.map((item, index) => (
                                    <Fragment
                                      key={`condensed-cat-${catIndex}-item-${index}`}
                                    >
                                      <Grid
                                        item
                                        xs={12}
                                        className={`${
                                          olItem.active === false
                                            ? "iInactive"
                                            : ""
                                        }`}
                                      >
                                        <ListItem
                                          type={1}
                                          data={item}
                                          setSelectedItem={setSelectedItem}
                                          setOpenItemDialog={setOpenItemDialog}
                                        />
                                      </Grid>
                                      <Grid item xs={12}>
                                        <Divider />
                                      </Grid>
                                    </Fragment>
                                  ))}
                                  {!category.rows.length ? (
                                    <>
                                      <Grid item xs={12} sm={12}>
                                        There are no products assigned to this
                                        category
                                      </Grid>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </Grid>
                              </Grid>
                            )),
                          )
                        ) : (
                          <>
                            {!orderListLoading && !orderListFull.length ? (
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                style={{ textAlign: "center" }}
                              >
                                <div>
                                  There are no Order Guide assigned to this
                                  customer
                                </div>
                              </Grid>
                            ) : (
                              <></>
                            )}
                          </>
                        )}
                      </>
                    ) : (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        style={{ textAlign: "center" }}
                      >
                        <CircularProgress />
                        <div>Loading products...</div>
                      </Grid>
                    )}
                  </>
                )}
              </>
              {orderNowElement()}
            </Grid>
          </>
        )}
      </Container>
      <ItemDialog
        data={selectedItem}
        openItemDialog={openItemDialog}
        setOpenItemDialog={setOpenItemDialog}
      />
      {!bannerDismissed && (
        <div
          style={{
            position: "fixed",
            left: "50%",
            bottom: !bannerVisible ? 0 : 18,
            zIndex: 1300,
            transform: bannerVisible
              ? "translate(-50%, 0)"
              : `translate(-50%, ${scrollDir === "down" ? "110%" : "130%"})`,
            opacity: bannerVisible ? 1 : 0.92,
            transition:
              "transform 320ms cubic-bezier(0.22, 1, 0.36, 1), opacity 220ms ease",
            width: "min(92vw, 640px)",
            pointerEvents: "auto",
          }}
        >
          <div
            style={{
              background: "linear-gradient(90deg, #b45b4d 0%, #a64f42 100%)",
              color: "#fff",
              borderRadius: 14,
              padding: "10px 14px",
              boxShadow: "0 12px 30px rgba(0,0,0,0.22)",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 12,
              flexDirection: xsWidth ? "column" : "row",
            }}
          >
            <div>
              <div style={{ fontWeight: 700, fontSize: 14 }}>
                Like our pricing?
              </div>
              <div style={{ fontSize: 12, opacity: 0.95 }}>
                Keep your inventory stocked with fast and secure ordering.
              </div>
            </div>
            <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>
              <Button
                size="small"
                variant="contained"
                onClick={() => window.location.assign("/login")}
                style={{ background: "#fff", color: "#6d352c" }}
              >
                Create Account
              </Button>
              <Button
                size="small"
                onClick={closeBanner}
                style={{ color: "#fff" }}
              >
                Dismiss
              </Button>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default OrdersDemo;
